@if (format() === "column") {
    <div class="wk-card-t1__column__head wk-card-job__column__head">
        <div #cardJobColumnName class="wk-card-t1__column__head-name wk-card-job__column__head-name">
            {{ cardData() | cardTitle }}
            @if (!tooltipDisabled()) {
                @if (isHovered()) {
                    <portal-pds3 elementId="wk-app__root">
                        <tooltip-pds3
                            mode="indicator"
                            position="bottom"
                            [openDelay]="400"
                            [closeDelay]="50"
                            [targetSelector]="`#${divId()} .wk-card-job__column__head-name`"
                        >
                            {{ cardData() | cardTitle }}
                        </tooltip-pds3>
                    </portal-pds3>
                }
            }
        </div>
        @if (cardData().job?.priority && cardData().job?.priority !== "") {
            <div class="wk-card-t1__column__head-priority wk-card-job__column__head-priority">
                <icon-pds3
                    name="wk-icon-filled-flag"
                    [ngClass]="{
                        'wk-card-job__column__head-priority--red': cardData().job?.priority === '1',
                        'wk-card-job__column__head-priority--blue': cardData().job?.priority === '2',
                        'wk-card-job__column__head-priority--green': cardData().job?.priority === '3',
                    }"
                />
                @if (isHovered()) {
                    <portal-pds3 elementId="wk-app__root">
                        <tooltip-pds3
                            mode="description"
                            position="left"
                            [openDelay]="400"
                            [closeDelay]="50"
                            [targetSelector]="`#${divId()} .wk-card-job__column__head-priority`"
                        >
                            {{ "JobsAndBilling.Priorities.Priority" | translate }}
                        </tooltip-pds3>
                    </portal-pds3>
                }
            </div>
        }
    </div>
    <div class="wk-card-t1__column__body">
        @if (dragDisabled() === true) {
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3
                        mode="description"
                        position="top"
                        [openDelay]="400"
                        [closeDelay]="50"
                        [targetSelector]="`#${divId()} .wk-card-t1__column__body`"
                    >
                        {{ "JobsAndBilling.Errors.SecurityRoleRequired" | translate }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        }
        <div class="wk-card-t1__column__body-left">
            <div class="wk-card-t1__column__body-t1">
                <icon-pds3 id="jobIcon_{{ divId() }}" name="wk-icon-book-open" class="wk-card-job__column__body-icon" />
                <span class="wk-card-job__column__body-icon--text">
                    {{ cardData().job?.id }} {{ jobTypeShortCode() }}
                    @if (cardData().job?.periodEndDate) {
                        {{ cardData().job?.periodEndDate * 1000 | date: "yyyy-MM-dd" }}
                    }
                </span>
                @if (isHovered()) {
                    <portal-pds3 elementId="wk-app__root">
                        <tooltip-pds3
                            mode="description"
                            position="right"
                            [openDelay]="400"
                            [closeDelay]="50"
                            [targetSelector]="'#jobIcon_' + divId()"
                        >
                            {{ "JobsAndBilling.Job" | translate }}
                        </tooltip-pds3>
                    </portal-pds3>
                }
            </div>
            @if (cardData().job?.targetEndDate) {
                <div class="wk-card-t1__column__body-date wk-card-job__target-end-date">
                    <i
                        class="wk-card-job__column__body-icon-date wk-card-job__column__body-icon-date--calendar"
                        [class.wk-card-job__column__body-icon-date--calendar--warning]="
                            cardViewService.currentViewType !== 'completed' && isDeadlineWarning && !isDeadlineAlert
                        "
                        [class.wk-card-job__column__body-icon-date--calendar--alert]="
                            cardViewService.currentViewType !== 'completed' && isDeadlineAlert && deadlineDate !== null
                        "
                    ></i>

                    <div
                        class="wk-card-job__column__body-icon-date-deadline"
                        [class.wk-card-job__column__body-icon-date-deadline--empty]="
                            deadlineDate === null || (!isDeadlineWarning && !isDeadlineAlert)
                        "
                        [class.wk-card-job__column__body-icon-date-deadline--warning]="
                            cardViewService.currentViewType !== 'completed' && deadlineDate !== null && isDeadlineWarning && !isDeadlineAlert
                        "
                        [class.wk-card-job__column__body-icon-date-deadline--alert]="
                            cardViewService.currentViewType !== 'completed' && deadlineDate !== null && isDeadlineAlert
                        "
                    >
                        {{
                            cardData().job?.targetEndDate * 1000
                                | date: (currentLanguage === "en-CA" ? "MMMM dd, yyyy" : "dd MMMM yyyy") : "" : currentLanguage
                        }}
                    </div>

                    @let tooltip = tooltipText();
                    @if (tooltip() !== "") {
                        @if (isHovered()) {
                            <portal-pds3 elementId="wk-app__root">
                                <tooltip-pds3
                                    mode="description"
                                    position="top"
                                    [openDelay]="400"
                                    [closeDelay]="50"
                                    [targetSelector]="`#${divId()} .wk-card-t1__column__body-date .wk-card-job__column__body-icon-date--calendar`"
                                >
                                    {{ tooltip() }}
                                </tooltip-pds3>
                            </portal-pds3>
                        }
                    }
                </div>
            }
        </div>
        <div class="wk-card-t1__column__body-gravatar">
            {{ assignedUser | UserInitial: "N/A" }}
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3
                        mode="indicator"
                        position="left"
                        [openDelay]="400"
                        [closeDelay]="50"
                        [targetSelector]="`#${divId()} .wk-card-t1__column__body-gravatar`"
                    >
                        {{ assignedUser | UserName: "N/A" }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        </div>
    </div>
    <div class="wk-card-t1__column__footer">
        <div class="wk-card-t1__column__footer-averagedays">
            <i class="wk-card-t1__icon wk-card-t1__icon--stopwatch"></i>
            <span>{{ daysSinceReady }} {{ "Dashboard.AverageDays" | translate }}</span>
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3
                        mode="description"
                        position="top"
                        [openDelay]="400"
                        [closeDelay]="50"
                        [targetSelector]="`#${divId()} .wk-card-t1__column__footer-averagedays .wk-card-t1__icon`"
                    >
                        {{ "Tooltips.NumberOfDaysSinceStart" | translate }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        </div>
        <div
            class="wk-card-t1__column__footer-dayssinceinstep"
            [class.wk-card-t1__column__footer-dayssinceinstep--danger]="cardViewService.currentViewType !== 'completed' && isStepAlert"
            [class.wk-card-t1__column__footer-dayssinceinstep--warning]="
                cardViewService.currentViewType !== 'completed' && !isStepAlert && isStepWarning
            "
            [class.wk-card-t1__column__footer-dayssinceinstep--quiet]="quietDaysFromNow > 0"
        >
            <i class="wk-card-t1__icon wk-card-t1__icon--clock"></i>
            <span class="wk-card__footer-days">
                {{ daysSinceInStep }}
                {{ "Dashboard.AverageDays" | translate }}
            </span>
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3
                        mode="description"
                        position="top"
                        [openDelay]="400"
                        [closeDelay]="50"
                        [targetSelector]="`#${divId()} .wk-card-t1__column__footer-dayssinceinstep .wk-card-t1__icon`"
                    >
                        {{ "Tooltips.NumberOfDaysSinceColumn" | translate }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        </div>
    </div>
} @else if (format() === "grid") {
    <div class="col-md-3 wk-card-t1__grid-name-column">
        {{ cardTitle() }}
    </div>
    <div class="col-md-2">Jobs &amp; Billing</div>
    <div class="col-md-2">{{ assignedUser | UserName: "N/A" }}</div>
}
